export function Gauge({
  value,
  color = 'var(--accent)',
  max = 100,
}: {
  value: number;
  color?: string;
  max?: number;
}) {
  const pct = max > 0 ? Math.max(0, Math.min(100, (value / max) * 100)) : 0;
  return (
    <div className="gauge">
      {/* scaleX, not width: stays on the compositor when the value updates. */}
      <span style={{ transform: `scaleX(${pct / 100})`, background: color }} />
    </div>
  );
}
